const isMobile = () => {
  return (
    Math.min(window.innerHeight, window.innerWidth) < 500 &&
    'onorientationchange' in window
  );
};

export default isMobile;
